var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecommendationletterRafiki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.14,
    y: 389.21,
    width: 46.75,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.8,
    y: 399.65,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.33,
    y: 395.31,
    width: 30.21,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.44,
    y: 395.31,
    width: 19.32,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.35,
    y: 399.53,
    width: 58.56,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.34,
    y: 79.69,
    width: 76.32,
    height: 286.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 79.69,
    width: 76.32,
    height: 286.98,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.3,
    y: 193.39,
    width: 271.72,
    height: 59.58,
    transform: "translate(615.34 -168.98) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.33,
    y: 221.42,
    width: 271.72,
    height: 3.52,
    transform: "translate(643.37 -197.01) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.46,
    y: 313.25,
    width: 69.4,
    height: 10.24,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.46,
    y: 100.77,
    width: 69.4,
    height: 10.24,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.68,
    y: 79.69,
    width: 76.32,
    height: 286.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.34,
    y: 79.69,
    width: 76.32,
    height: 286.98,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -29.36,
    y: 193.39,
    width: 271.72,
    height: 59.58,
    transform: "translate(329.68 116.68) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.33,
    y: 221.42,
    width: 271.72,
    height: 3.52,
    transform: "translate(357.71 88.65) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.8,
    y: 313.25,
    width: 69.4,
    height: 10.24,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.8,
    y: 100.77,
    width: 69.4,
    height: 10.24,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.62,
    y: 101.73,
    width: 152.38,
    height: 145,
    transform: "translate(503.62 348.45) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 101.73,
    width: 3.62,
    height: 145,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.31,
    y: 104.03,
    width: 133,
    height: 140.38,
    transform: "translate(426.04 -77.58) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.62,173.73c46.29-5.34,92.59,5.33,138.88,0v-2.67c-46.29,5.33-92.59-5.33-138.88,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.75,
    y: 173.48,
    width: 133,
    height: 1.5,
    transform: "translate(495.48 -147.02) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.75,352.83a2.62,2.62,0,0,1-2-4.24c1.48-1.87-2.12-6.2-5.93-10.79-8.12-9.76-20.39-24.52-3.63-41.45,10.57-10.68,10.34-15.1,9.75-16.51-1.05-2.5-6-3.06-7.6-3h0a2.62,2.62,0,0,1,0-5.23c1,0,9.86.07,12.46,6.21,2.25,5.31-1.3,12.59-10.85,22.23-13.42,13.55-4.19,24.64,3.94,34.43,5.21,6.27,10.13,12.18,6,17.38A2.6,2.6,0,0,1,137.75,352.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.91 329.26 155.7 329.26 143.35 382.4 112.27 382.4 99.91 329.26",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.33,331.64h57a2.39,2.39,0,0,0,2.38-2.38h0a2.38,2.38,0,0,0-2.38-2.37H99.33A2.38,2.38,0,0,0,97,329.26h0A2.38,2.38,0,0,0,99.33,331.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.41,273.3,94.7,290.71s-19.1-12.9-5.23-18.7c-6.59-11.25-7.43-33.2,13.8-39.56S123,257.09,123,257.09s26.18-27.69,25,5.2C153,260.92,174.13,265.93,147.41,273.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.42,297.13h63.92s16.86-11.9-.8-11.3c3.51-15.18-6.37-31.81-28.68-32.45s-14.46,24.11-14.46,24.11S85.93,268.56,97.27,287C78.7,287.91,88.3,292.67,103.42,297.13Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.46,300.57l-50.22,1.81a7.74,7.74,0,0,1-6.6-3.55c-1.9-2.69-2.4-6,5.63-7-2.57-7.94,3.11-21.77,23.87-22.84s10.35,18.12,10.35,18.12,31.41-13.71,20.69,6.68C163,293.59,180.39,299.64,154.46,300.57Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.91,139.22c-8.13-1.14-15.13,20.91-8.13,26.24s22.64,8.2,36.61,2c10.17-4.49,8.32-14.74,1.25-26.16C182.94,132.13,170.43,122.42,158.91,139.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.1,187.65c.46,5.53.8,11.08,1.1,16.62s.55,11.1.77,16.65l-.16-.86a1.74,1.74,0,0,0-.35-.66c-.06-.06,0,0,0,0a5.33,5.33,0,0,0,.67.56,19.62,19.62,0,0,0,2.2,1.34c1.63.86,3.42,1.7,5.24,2.47s3.68,1.55,5.55,2.31l5.63,2.25-1.09,4.32c-2.1-.26-4.13-.64-6.19-1s-4.09-.89-6.13-1.44a60,60,0,0,1-6.17-2,25,25,0,0,1-3.22-1.53,11.08,11.08,0,0,1-1.81-1.24,8.1,8.1,0,0,1-1-1.06,5.71,5.71,0,0,1-1.09-2l-.1-.32-.06-.54c-.55-5.53-1.1-11.07-1.53-16.61s-.9-11.09-1.21-16.64Z",
    style: {
      fill: "#b65b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.47,180.21c1.94,4.23,3,15.54,3.25,31.73a23.67,23.67,0,0,0-9.74,4.83l-4.38-25.43,2.43-4.23a10.57,10.57,0,0,1,8.44-6.9Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.47,180.21c1.94,4.23,3,15.54,3.25,31.73a23.67,23.67,0,0,0-9.74,4.83l-4.38-25.43,2.43-4.23a10.57,10.57,0,0,1,8.44-6.9Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.1,227.76l8.33-.44-5.07,6.7s-5.25-.76-6.42-4Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.26,233.51l-1.43,1.69a2.62,2.62,0,0,1-3.05.72l-4.42-1.9,5.07-6.7,3.33,2.34A2.62,2.62,0,0,1,225.26,233.51Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.08,182.88c.14,6-.7,18.45-4.92,44.35H154.6c.56-13.66,1.23-22.22-5.3-50.26a93.15,93.15,0,0,1,13.6-1.74,107.54,107.54,0,0,1,15.24,0c3.29.3,6.79.83,9.47,1.29A6.59,6.59,0,0,1,193.08,182.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.74,192.34a.21.21,0,0,1-.17-.07c-2.59-2.93-7.24-10.61-7.3-15.51a.23.23,0,0,1,.23-.23.23.23,0,0,1,.24.23c0,4.28,4.09,11.58,7,15a22.32,22.32,0,0,1,5.77-5.54.23.23,0,0,1,.32.07.24.24,0,0,1-.06.32,21.9,21.9,0,0,0-5.8,5.66.2.2,0,0,1-.18.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.58,192.34h0a.21.21,0,0,1-.18-.11,21.75,21.75,0,0,0-5.79-5.66.23.23,0,0,1,.25-.39,22.32,22.32,0,0,1,5.77,5.54c2.59-3.34,1.84-11,.11-15.1a.23.23,0,0,1,.12-.31.24.24,0,0,1,.31.13c1.82,4.36,2.56,12.49-.39,15.83A.24.24,0,0,1,181.58,192.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.41,158.07c1,4.9,1.92,13.89-1.51,17.16a25,25,0,0,0,11.82,10c6.56-4.11,3.42-10,3.42-10-5.47-1.31-5.32-5.36-4.37-9.17Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.23,161.33l5.53,4.72a17.29,17.29,0,0,0-.47,2.71c-2.08-.3-4.95-2.6-5.18-4.79A7.24,7.24,0,0,1,168.23,161.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.24,149.07c1.92,8,2.57,11.39,7.37,14.81,7.23,5.14,16.6,1,17.1-7.36.45-7.55-2.77-19.32-11.23-21.13A11.19,11.19,0,0,0,159.24,149.07Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.46,140.42c5,2.79,21.95,1.79,19.43-3.3S165.62,133.29,159.46,140.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.21,140.17c4.37,6.21,3.12,14.77-6.63,14.8S153.67,138,163.21,140.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.43,155l9,1.21s-1.15,2.59-5.36,2C170.59,157.62,170.43,155,170.43,155Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.16,227.23s-2.83,62.23-3.37,87.43c-.57,26.22-.82,87.44-.82,87.44h-6.61s-10.56-50.88-7.43-87.44c-4.73-28.07-7.92-87.43-7.92-87.43Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.39,227.23s-14,64.81-20.7,89.1c-5,18.23-39.84,70.08-40.09,72l-5.27-2.9s20.36-56.72,29.43-72.83c0-28.47,11.84-85.33,11.84-85.33Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.05,149c.12.66.56,1.13,1,1s.68-.67.57-1.32-.56-1.13-1-1.05S172.94,148.34,173.05,149Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,147.68c.12.65.56,1.13,1,1s.68-.67.57-1.33-.56-1.12-1-1.05S180.36,147,180.47,147.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.86,146.42l1.49-.73S181.76,147.06,180.86,146.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.07,148.86a18,18,0,0,0,3.09,3.77,2.89,2.89,0,0,1-2.27.85Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.12,153.62a6,6,0,0,0,3.25,3.23c1.95.78,3.16-.91,2.81-2.87-.32-1.76-1.71-4.3-3.76-4.25A2.7,2.7,0,0,0,158.12,153.62Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.63,145.85a.45.45,0,0,0,.25-.18,3.11,3.11,0,0,1,2.38-1.54.4.4,0,0,0,.38-.4.39.39,0,0,0-.41-.38,3.84,3.84,0,0,0-3,1.91.39.39,0,0,0,.12.54A.43.43,0,0,0,169.63,145.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,143.76a.35.35,0,0,0,.25-.14.39.39,0,0,0-.06-.55,3.91,3.91,0,0,0-3.49-.78.4.4,0,0,0,.25.75,3.1,3.1,0,0,1,2.75.64A.42.42,0,0,0,182,143.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.44,147.74l1.49-.74S174.34,148.38,173.44,147.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,231.7l-1.5,83s-10.43,1.87-22.72-4.48a43,43,0,0,0-23.71-4.68c-2.69-50.28,6.1-66.09,12.84-73.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.25 283.72 163.64 269.95 157.57 258.74 182.25 283.72",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.07,222.11l-1.24,11.64c-8.9,1.07-21.84.68-35.59,0l1.09-11.64C167.27,222.55,179.58,222.71,190.07,222.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,174.59s.26,65-2.84,80.72c-5.12-4.81-12.19-16-12.19-16s4-12.69,5.11-15.72c-.62-4.57-5.74-42.49-5-46.44C152.23,175.36,162,174.59,162,174.59Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,174.59s.26,65-2.84,80.72c-5.12-4.81-12.19-16-12.19-16s4-12.69,5.11-15.72c-.62-4.57-5.74-42.49-5-46.44C152.23,175.36,162,174.59,162,174.59Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.91,187.06c-2.56,3.47-5.14,7.11-7.6,10.72s-4.86,7.28-7,11c-.53.93-1,1.86-1.51,2.79-.26.46-.49.93-.7,1.39l-.61,1.27c0-.15,0-.34,0-.34s0,.15,0,.38a7.28,7.28,0,0,0,1.22,1.87,33,33,0,0,0,4.38,4.13c1.64,1.33,3.43,2.66,5.15,3.88l-1.93,4a48.11,48.11,0,0,1-6.54-2.75,31.48,31.48,0,0,1-6.21-4.11,13.82,13.82,0,0,1-2.9-3.42,8.48,8.48,0,0,1-1.06-2.77,7.28,7.28,0,0,1,.25-3.65l.08-.22,0-.12.09-.22.17-.42.34-.84c.22-.58.45-1.13.7-1.67.49-1.09,1-2.17,1.53-3.2a125.13,125.13,0,0,1,7-12c1.24-1.92,2.53-3.81,3.85-5.67s2.65-3.69,4.1-5.54Z",
    style: {
      fill: "#b65b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23,223.73l8.91-.67-4.92,6.81s-5.27-.65-6.51-3.85Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,229.27l-1.3,1.6a2.74,2.74,0,0,1-3.09.85l-4.41-1.85,4.92-6.81,3.27,2.19A2.76,2.76,0,0,1,156,229.27Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.82,174.59s3.76,25.84,4.44,46.52c.41,12.41-1.85,28.2-1.59,34.2a32.31,32.31,0,0,0,7.44-11.56s1.52-5.42-.36-20.16c.51-3.72,2.76-29.26,3.2-40.75a6.57,6.57,0,0,0-5-6.64C184.77,175.21,180.82,174.59,180.82,174.59Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.82,174.59s3.76,25.84,4.44,46.52c.41,12.41-1.85,28.2-1.59,34.2a32.31,32.31,0,0,0,7.44-11.56s1.52-5.42-.36-20.16c.51-3.72,2.76-29.26,3.2-40.75a6.57,6.57,0,0,0-5-6.64C184.77,175.21,180.82,174.59,180.82,174.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.24,191.17c-.36,0-.74-.48-.89-1.18h0c-.16-.74,0-1.37.4-1.45s.84.43,1,1.17a1.7,1.7,0,0,1-.12,1.24.52.52,0,0,1-.31.22Zm-.66-1.23c.14.64.49,1,.7,1a.25.25,0,0,0,.16-.12,1.56,1.56,0,0,0,.08-1.06c-.13-.63-.49-1-.72-1s-.36.54-.22,1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3,198.19c-.39,0-.73-.53-.81-1.25s.15-1.34.55-1.39a.5.5,0,0,1,.37.13,1.75,1.75,0,0,1,.5,1.12,1.69,1.69,0,0,1-.25,1.2.49.49,0,0,1-.33.19Zm-.21-2.41h0c-.23,0-.42.48-.35,1.12s.35,1,.58,1h0a.24.24,0,0,0,.17-.1,1.47,1.47,0,0,0,.2-1,1.49,1.49,0,0,0-.42-1A.29.29,0,0,0,176.09,195.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62,205.17h0c-.4,0-.7-.58-.71-1.31h0c0-.74.29-1.3.69-1.31a.47.47,0,0,1,.35.16,1.67,1.67,0,0,1,.39,1.15A1.74,1.74,0,0,1,177,205,.53.53,0,0,1,176.62,205.17Zm-.49-1.31c0,.63.26,1.07.49,1.08h0a.28.28,0,0,0,.18-.1,1.41,1.41,0,0,0,.29-1,1.43,1.43,0,0,0-.31-1,.26.26,0,0,0-.18-.09h0c-.22,0-.46.44-.46,1.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.24,212.05h-.06c-.39-.05-.64-.63-.57-1.35h0c.07-.73.43-1.26.82-1.22a.54.54,0,0,1,.34.19,1.73,1.73,0,0,1,.26,1.17,1.66,1.66,0,0,1-.48,1.09A.51.51,0,0,1,176.24,212.05Zm-.4-1.33c-.06.62.15,1.07.37,1.1a.27.27,0,0,0,.2-.07,1.46,1.46,0,0,0,.39-.93,1.54,1.54,0,0,0-.21-1,.3.3,0,0,0-.18-.11h0c-.22,0-.49.4-.55,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.63,218.81h0c-.4-.05-.64-.63-.57-1.35h0c.06-.7.4-1.21.78-1.21h0a.5.5,0,0,1,.34.19,1.63,1.63,0,0,1,.25,1.16,1.58,1.58,0,0,1-.47,1.08A.51.51,0,0,1,175.63,218.81Zm.16-2.32c-.22,0-.49.39-.55,1h0c-.06.62.14,1.07.37,1.1a.29.29,0,0,0,.2-.08,1.41,1.41,0,0,0,.38-.92,1.43,1.43,0,0,0-.2-1,.26.26,0,0,0-.18-.11Zm-.67,1h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.78,191.49a30.72,30.72,0,0,1-1.91,7c-.2-1.71-.4-3.42-.58-5.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,177.15c-3.72,2.79-11.19,14.29-19.1,28.41a91.83,91.83,0,0,1,7.39,6.83l16-20.28-.12-4.88A10.54,10.54,0,0,0,147,177.15Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,177.15c-3.72,2.79-11.19,14.29-19.1,28.41a91.83,91.83,0,0,1,7.39,6.83l16-20.28-.12-4.88A10.54,10.54,0,0,0,147,177.15Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,396.08c1.17,9.8,7.42,17.38,7.42,17.38l-10.17-2.61-4.64-7.29,1-1.92Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2,401.09a5.92,5.92,0,0,0-.56,2.71c.06,3.39.44,12.4.44,12.4h.8a77.14,77.14,0,0,1,.42-8.3c.39-2.24,2,.41,2.86,2.94s4.45,5.24,9.62,5.36c6.06.15,8.52-.12,6.76-1.59s-5.78-2.41-5.78-2.41a9.41,9.41,0,0,1-8-4.89c-1.8-3.25-4-6.48-5.49-7.24A1.66,1.66,0,0,0,176.2,401.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.71,386.21c-2.79,6.87-3.11,17.28-3.11,17.28L110,393.78l1.28-8.54,2-.78Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,383.11a5.8,5.8,0,0,0-2.19,1.67c-2.19,2.6-7.81,9.65-7.81,9.65l.6.52a78.24,78.24,0,0,1,5.77-6c1.76-1.43,1.22,1.61.22,4.1s-.08,6.87,3.74,10.36c4.47,4.09,6.5,5.5,6.14,3.24S116.3,401,116.3,401a9.41,9.41,0,0,1-2.8-8.91c.77-3.64,1.25-7.51.61-9.07A1.68,1.68,0,0,0,112.6,383.11Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Letter--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223,233.63H378.19a17.37,17.37,0,0,1,17.05,16l6.1,95.34a14.9,14.9,0,0,1-15,16H231.1a17.38,17.38,0,0,1-17-16L208,249.65A14.89,14.89,0,0,1,223,233.63Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,233.63H378.19a17.37,17.37,0,0,1,17.05,16l6.1,95.34a14.9,14.9,0,0,1-15,16H231.1a17.38,17.38,0,0,1-17-16L208,249.65A14.89,14.89,0,0,1,223,233.63Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.11,361H386.33a14.84,14.84,0,0,0,10.27-4l-92.82-73.2L220.3,357A16.78,16.78,0,0,0,231.11,361Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.11,361H386.33a14.84,14.84,0,0,0,10.27-4l-92.82-73.2L220.3,357A16.78,16.78,0,0,0,231.11,361Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.26,307l81.17-71.17a16.58,16.58,0,0,0-8.24-2.22H223a15.15,15.15,0,0,0-8,2.22Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.1,234l-5.41-84.7a9.29,9.29,0,0,0-9.15-8.61h-121a9.31,9.31,0,0,1,9.16,8.61l5.37,84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.1,235.23a1.26,1.26,0,0,1-1.26-1.18l-5.41-84.7a8,8,0,0,0-7.89-7.42H232.26a10.48,10.48,0,0,1,3.69,7.26l5.37,84a1.27,1.27,0,1,1-2.53.16l-5.36-84a8,8,0,0,0-7.9-7.42,1.27,1.27,0,0,1,0-2.53h121A10.59,10.59,0,0,1,357,149.19l5.42,84.7a1.27,1.27,0,0,1-1.19,1.34Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53,140.66a8,8,0,0,0-8.06,8.61h17.22A9.31,9.31,0,0,0,225.53,140.66Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.69,150.54H217.47a1.26,1.26,0,0,1-1.26-1.19,9.24,9.24,0,0,1,9.32-9.95A10.6,10.6,0,0,1,236,149.19a1.29,1.29,0,0,1-.34.95A1.3,1.3,0,0,1,234.69,150.54ZM218.75,148h14.47a8,8,0,0,0-7.69-6.08,6.68,6.68,0,0,0-6.78,6.08Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.54,140.66h-121a9.31,9.31,0,0,1,9.16,8.61l6.87,107.51L305.26,307l57.34-49.56-6.91-108.19A9.29,9.29,0,0,0,346.54,140.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.56 256.78 305.25 307.02 362.6 257.46 300.71 298.33 241.56 256.78",
    style: {
      fill: "#6B5393",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.48 208.7 248.49 208.7 247.98 200.83 348.98 200.83 349.48 208.7",
    style: {
      fill: "#6B5393",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.68 233.09 250.04 233.09 249.54 225.22 328.18 225.22 328.68 233.09",
    style: {
      fill: "#6B5393",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.6 257.48 293.24 257.48 292.74 249.6 352.1 249.6 352.6 257.48",
    style: {
      fill: "#6B5393",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.6 257.48 283.38 257.48 282.87 249.6 251.1 249.6 251.6 257.48",
    style: {
      fill: "#6B5393",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "321.61 86.83 320.61 86.83 320.16 80.33 321.16 80.33 321.61 86.83",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.82,75.33h-1l-1-13.78a18.17,18.17,0,0,0-3.78-9.86l.78-.57a19.28,19.28,0,0,1,4,10.43Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.79,46.78H300.56a16.13,16.13,0,0,1,15.8,14.77l3.55,51.27a13.64,13.64,0,0,1-13.75,14.78h-7.45l1.3,18.69L280,127.6H205.39a16.14,16.14,0,0,1-15.8-14.78L186,61.55A13.65,13.65,0,0,1,199.79,46.78Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.34,84.51h.19a4.35,4.35,0,0,1-4.2-3.48h0a4.15,4.15,0,0,1,4.18-4.5H228L244.25,75a72.24,72.24,0,0,1-1.46-8.5c-.47-4.71,2.24-10.52,6.73-8.44,1.81.84,1.16,6.69,2.17,9s9.55,9.14,12.15,14h0a4,4,0,0,1,2.51,3.42l1.07,15.43a8,8,0,0,1-2.07,6h0a8,8,0,0,1-5.85,2.49H232.74a4.47,4.47,0,0,1-4.24-3,3.7,3.7,0,0,1,3.53-4.93h-3.42A3.79,3.79,0,0,1,224.89,97h0a3.69,3.69,0,0,1,3.64-4.5h-1.82a4.35,4.35,0,0,1-4.25-3.84A3.78,3.78,0,0,1,226.34,84.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.35,108.43h5a2.75,2.75,0,0,0,2.77-3l-1.55-22.37a3.25,3.25,0,0,0-3.19-3h-4.95a2.76,2.76,0,0,0-2.78,3l1.55,22.37A3.26,3.26,0,0,0,274.35,108.43Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationletterRafiki);
export default __webpack_public_path__ + "static/media/Recommendation letter-rafiki.ad18c0d55cf267350996bae9f3e6559a.svg";
export { ForwardRef as ReactComponent };